<template>
  <b-card no-body class="rounded-xl h-full border-b-none">
    <modal size="md" :show.sync="creategroup" header-classes="bg-primary p-3">
      <h6
        slot="header"
        class="modal-title uppercase text-white font-semibold pt-1"
      >
        Create Group
      </h6>
      <CreateGroup />
      <template slot="footer">
        <base-button type="primary">Add Group</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="creategroup = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <modal size="md" :show.sync="uploadnumber" header-classes="bg-primary p-3">
      <h6
        slot="header"
        class="modal-title uppercase text-white font-semibold pt-1"
      >
        Upload Number
      </h6>
      <UploadNumber />
      <template slot="footer">
        <base-button type="primary">Add Group</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="uploadnumber = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="row">
      <div class="col-sm-12">
        <b-card class="border-none">
          <div class="flex justify-end">
            <base-button outline type="success" @click="creategroup = true"
              >Create Group</base-button
            >
            <base-button outline type="success" @click="uploadnumber = true"
              >Upload Number</base-button
            >
          </div>
          <b-card-text><GroupTable /></b-card-text>
        </b-card>
      </div>
    </div>
  </b-card>
</template>

<script>
import GroupTable from "./components/GroupTable";
import CreateGroup from "./components/CreateGroup";
import UploadNumber from "./components/UploadNumber";

import "../../../scss/Index.scss";
export default {
  components: {
    GroupTable,
    CreateGroup,
    UploadNumber,
  },
  data() {
    return { creategroup: false, uploadnumber: false };
  },
};
</script>
<style>
.tab-pd-b .nav-link {
  padding: 10px 15px !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #fff !important;
}
.card-h-bgf4f5f6 > div > .card-header {
  background: #f4f5f6 !important;
}
</style>
